// The copy is published by `@heidi/agents/data`; the toast itself stays in /ui
// because the headless zones refuse a toaster.
import { runStartedToastMessages } from '@heidi/agents/data';
import { toast } from '@heidi/design-system/toast';
import type { IntlShape } from 'react-intl';

/**
 * A run can start without a chat shell behind it (no project id). Nothing to
 * open, but the click must not read as dead — confirm the kick-off.
 */
export function notifyRunStartedWithoutChat(intl: IntlShape): void {
  toast({
    title: intl.formatMessage(runStartedToastMessages.runStarted),
    tone: 'success',
  });
}
